"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _applyDecoratedDescriptor2 = _interopRequireDefault(require("@babel/runtime/helpers/applyDecoratedDescriptor"));
var _models = require("@seedlang/models");
var _mobx = require("mobx");
var _constants = require("@seedlang/constants");
var _utils = require("@seedlang/utils");
var _root_store = _interopRequireDefault(require("./root_store"));
var _class;
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var DailyReviewSummaryStore = (_class = /*#__PURE__*/function (_RootStore) {
  function DailyReviewSummaryStore() {
    var _this;
    (0, _classCallCheck2["default"])(this, DailyReviewSummaryStore);
    _this = _callSuper(this, DailyReviewSummaryStore);
    _this.config = {
      model: _models.DailyReviewSummary,
      deserialize: true,
      GET: {
        index: '/daily_review_summaries'
      }
    };
    return _this;
  }
  (0, _inherits2["default"])(DailyReviewSummaryStore, _RootStore);
  return (0, _createClass2["default"])(DailyReviewSummaryStore, [{
    key: "forChart",
    get: function get() {
      if (!this.hasIndexData) {
        return [];
      }
      var data1 = this.indexData.filter(function (item) {
        return (0, _utils.isPresent)(item.occurredAt) && item.occurredAt.date;
      }).map(function (item) {
        return {
          x: item.occurredAt.formattedDate,
          y: item.pastDueCount
        };
      }).reverse();
      var data2 = this.indexData.filter(function (item) {
        return (0, _utils.isPresent)(item.occurredAt) && item.occurredAt.date;
      }).map(function (item) {
        return {
          x: item.occurredAt.formattedDate,
          y: item.upToDateCount
        };
      }).reverse();
      var data3 = this.indexData.filter(function (item) {
        return (0, _utils.isPresent)(item.occurredAt) && item.occurredAt.date;
      }).map(function (item) {
        return {
          x: item.occurredAt.formattedDate,
          y: item.retiredCount
        };
      }).reverse();
      return [{
        id: 'Retired',
        data: data3,
        color: _constants.Theme.purple
      }, {
        id: 'Caught Up',
        data: data2,
        color: _constants.Theme.green
      }, {
        id: 'Due',
        data: data1,
        color: 'transparent'
      }];
    }
  }]);
}(_root_store["default"]), (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "forChart", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "forChart"), _class.prototype), _class);
var _default = exports["default"] = new DailyReviewSummaryStore();